// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1e871ebN1s","centered":"centered-3GXjFIQX3u"};